function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as FileSystem from 'expo-file-system';
import React from 'react';
import { Image, Pressable, View } from 'react-native';
import { ImageLoader } from './ImageLoader';
export const Img = ({
  onPress,
  width,
  height,
  uri,
  cacheKey,
  source,
  style,
  containerStyle,
  ...props
}) => {
  const Component = onPress != null ? Pressable : View;
  const fileSystemURI = `${FileSystem.cacheDirectory}${cacheKey}`;
  const [imgURI, setImgURI] = React.useState(fileSystemURI);
  const isMounted = React.useRef(true);
  const isLoading = React.useRef(true);
  React.useEffect(() => {
    async function loadImage(fileURI) {
      try {
        const metadata = await FileSystem.getInfoAsync(fileURI);

        if (!metadata.exists && uri) {
          setImgURI(undefined);
          await FileSystem.downloadAsync(uri, fileURI);
        }

        if (isMounted.current) {
          setImgURI(fileURI);
          isLoading.current = false;
        }
      } catch (err) {
        setImgURI(undefined);
      }
    }

    loadImage(fileSystemURI);
    return () => {
      isMounted.current = false;
    };
  }, []);
  return /*#__PURE__*/React.createElement(Component, {
    style: [{
      overflow: 'hidden'
    }, containerStyle]
  }, isLoading.current ? /*#__PURE__*/React.createElement(ImageLoader, {
    style: containerStyle
  }) : /*#__PURE__*/React.createElement(Image, _extends({}, props, {
    source: Boolean(uri) ? {
      uri: imgURI
    } : source,
    style: [{
      width,
      height
    }, style]
  })));
};
//# sourceMappingURL=index.js.map